module.exports = __webpack_public_path__ + "img/logo-talentplug.01e5429f.svg";